"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextPublishRequestSchema = exports.TransferInitialRequestSchema = exports.ForwardRequestSchema = exports.RejectRequestSchema = exports.ApproveRequestSchema = exports.SubmitRequestSchema = exports.SignerInputSchema = void 0;
const zod_1 = require("zod");
exports.SignerInputSchema = zod_1.z.object({
    staffId: zod_1.z.number().int(),
    role: zod_1.z.number().int(), // SYS_ROLE_ID (LDDV/TTDV/VT/etc)
    level: zod_1.z.number().int().min(1).max(20),
    parallelPosition: zod_1.z.number().int().optional(),
});
exports.SubmitRequestSchema = zod_1.z
    .object({
    title: zod_1.z.string().min(1).max(500),
    description: zod_1.z.string().optional(),
    code: zod_1.z.string().max(100).optional(),
    typeId: zod_1.z.number().int().optional(),
    priorityId: zod_1.z.number().int().optional(),
    areaId: zod_1.z.number().int().optional(),
    stypeId: zod_1.z.number().int().optional(),
    publishOrgId: zod_1.z.number().int().optional(),
    officeSender: zod_1.z.string().max(200).optional(),
    recieverPlace: zod_1.z.string().max(200).optional(),
    autoPublish: zod_1.z.boolean().optional(),
    parallelSign: zod_1.z.boolean().optional(),
    mainFileId: zod_1.z.number().int().optional(),
    attachmentFileIds: zod_1.z.array(zod_1.z.number().int()).default([]),
    orgReceivers: zod_1.z.array(zod_1.z.number().int()).default([]),
    personalReceivers: zod_1.z.array(zod_1.z.number().int()).default([]),
    signers: zod_1.z.array(exports.SignerInputSchema).default([]),
    // Khi bật: lưu văn bản ở STATE=0 (nháp). Danh sách người ký VẪN được ghi vào
    // TEXT_PROCESS để mở lại nháp còn thấy, nhưng không tạo TEXT_SIGN_NEXT nên
    // chưa ai bị đẩy vào hàng chờ ký.
    saveAsDraft: zod_1.z.boolean().optional(),
})
    .refine((v) => v.saveAsDraft || v.signers.length > 0, {
    message: "Phải có ít nhất 1 người ký (chỉ trừ khi lưu nháp)",
    path: ["signers"],
});
exports.ApproveRequestSchema = zod_1.z.object({
    signType: zod_1.z.enum(["image", "usb", "hsm"]).default("image"),
    comment: zod_1.z.string().max(2000).optional(),
    signImageId: zod_1.z.number().int().optional(),
});
exports.RejectRequestSchema = zod_1.z.object({
    comment: zod_1.z.string().min(1).max(2000),
});
exports.ForwardRequestSchema = zod_1.z.object({
    toStaffId: zod_1.z.number().int(),
    toRole: zod_1.z.number().int(),
    comment: zod_1.z.string().max(2000).optional(),
});
exports.TransferInitialRequestSchema = zod_1.z.object({
    /** Danh sách staffId người được uỷ quyền ký nháy (1..10 người). */
    initialerStaffIds: zod_1.z.array(zod_1.z.number().int()).min(1).max(10),
    comment: zod_1.z.string().max(2000).optional(),
});
exports.TextPublishRequestSchema = zod_1.z.object({
    // #4279: để trống = hệ thống tự cấp số; có nhập = văn thư ghi đè thủ công (được validate không trùng).
    registerNumber: zod_1.z.string().max(100).optional(),
    publishDate: zod_1.z.string().optional(),
    personalReceivers: zod_1.z.array(zod_1.z.number().int()).default([]), // staffIds
    orgReceivers: zod_1.z.array(zod_1.z.number().int()).default([]), // orgIds
    commentSend: zod_1.z.string().max(2000).optional(),
});
